module.exports = __webpack_public_path__ + "static/media/winter.7a9fef14.png";